import { render, staticRenderFns } from "./NewDiagnoseModal.vue?vue&type=template&id=1eb5db88&scoped=true"
import script from "./NewDiagnoseModal.vue?vue&type=script&lang=js"
export * from "./NewDiagnoseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb5db88",
  null
  
)

export default component.exports